import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import * as d3 from 'd3';

import metricsTools from '../../utils/metricsTools';
import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';

const pushAccountData = (res, timeRangeElement) => {
    res[0].values.push(
        [
            timeRangeElement.timeRange,
            timeRangeElement.incomingBytes,
        ]
    );
    res[1].values.push(
        [
            timeRangeElement.timeRange,
            timeRangeElement.outgoingBytes,
        ]
    );
};

const formatDataForChart = data => {
    const res = [
        {
            key: 'In.',
            values: [],
            area: false,
            color: '#23afa6',
        },
        {
            key: 'Out.',
            values: [],
            area: false,
            color: '#0270e2',
        },
    ];

    // Remove future metrics
    const now = new Date();
    const metrics = data.filter(metric => new Date(metric.timeRange) <= now);

    for (let i = 0; i < metrics.length; i += 1) {
        const timeRangeElement = metrics[i];
        pushAccountData(res, timeRangeElement);
    }
    return res;
};


const context = {
    formatXAxis: d => (d3.time.format('%m/%d %H:%M')(new Date(d))),
    formatYAxis: d => metricsTools.bytesToSize(d),
};


class IOLineChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="barChart"
              type={this.props.disableFocus
                ? 'lineChart' : 'lineWithFocusChart'}
              datum={formatDataForChart(this.props.data)}
              context={context}
              xAxis={{
                  tickFormat: {
                      name: 'formatXAxis',
                      type: 'function',
                  },
              }}
              x2Axis={{
                  tickFormat: {
                      name: 'formatXAxis',
                      type: 'function',
                  },
              }}
              yAxis={{
                  tickFormat: {
                      name: 'formatYAxis',
                      type: 'function',
                  },
              }}
              margin={{ right: 80, left: 40 }}
              useInteractiveGuideline={true}
              rightAlignYAxis={true}
              clipEdge={true}
              showControls={true}
              x={ d => {
                  const date = new Date(d[0]);
                  return date.getTime();
              }}
              y={ d => (d[1])}
              height={this.props.height || 400}
            />
          </div>
        );
    }
}

IOLineChartComponent.propTypes = {
    data: PropTypes.array.isRequired,
    height: PropTypes.number,
    disableFocus: PropTypes.bool,
};

export default IOLineChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/IOLineChartComponent.js
 **/